import { Sensor } from "@aas2/aas2-sensing-service";

export class Diary {
  diaryId: number;
  title: string;
  description: string;
  picture: string;
  studyId: number;
  lessonId: number;
  pageColor: string;
  sensorData: Sensor[];
  smallLayout: 0 | 1;

  constructor(
    diaryId: number,
    title: string,
    description: string,
    picture: string,
    studyId: number,
    lessonId: number,
    pageColor: string,
    sensorData: Sensor[],
    smallLayout: 0 | 1,
  ) {
    this.diaryId = diaryId;
    this.title = title;
    this.description = description;
    this.picture = picture;
    this.studyId = studyId;
    this.lessonId = lessonId;
    this.pageColor = pageColor;
    this.sensorData = sensorData;
    this.smallLayout = smallLayout;
  }
}
